import { useSelector } from "react-redux";
import FptTrasladosContainer from "../fptTraslados/fptTrasladosContainer";
import { fptHasTraslados } from "../fptTraslados/fptTrasladosUtils";
import {
  loadsExistingDocument,
  savesAsNewDocument,
} from "../formRepeatUtils";
import FptContainer from "./fptContainer";

const FptFormContainer = ({ isView, isRepeatForm = false, ...props }) => {
  const model = useSelector((state) => state.forms.model);
  const form = useSelector((state) => state.forms.form);
  const loadsExisting = loadsExistingDocument(isView, isRepeatForm);
  const configuration = loadsExisting
    ? form.data?.model?.configuration
    : model.data?.configuration;
  const useTraslados =
    configuration?.trasladosEnabled &&
    (savesAsNewDocument(isView, isRepeatForm) ||
      fptHasTraslados(form.data?.form));
  const Component = useTraslados ? FptTrasladosContainer : FptContainer;

  return (
    <Component {...props} isRepeatForm={isRepeatForm} isView={isView} />
  );
};

export default FptFormContainer;
